<template>
  <section class="defaultSectionMargins container--Small">
    <div id="CookieDeclaration" ref="cookieDeclaration"></div>
  </section>
</template>

<script setup>
  defineProps({
    data: {},
  });

  const LANGUAGE_MAP = {
    hr: 'hr-HR',
    en: 'en-150',
    de: 'de-DE',
    it: 'it-IT',
    sl: 'sl-SI',
    nl: 'nl-NL',
    pl: 'pl-PL',
  };

  const WEBSITE_KEY = 'cbc5ca3f-e64e-443f-a29d-56db1b5267bc';
  const SCRIPT_ID = 'cookietractor-declaration-script';

  const { lang } = useLanguage();
  const cookieDeclaration = ref(null);
  let stopWatch;

  function loadCookieDeclaration(value) {
    document.getElementById(SCRIPT_ID)?.remove();
    if (cookieDeclaration.value) cookieDeclaration.value.innerHTML = '';

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = 'https://cdn.cookietractor.com/cookietractor-declaration.js';
    script.setAttribute('data-lang', LANGUAGE_MAP[value] || 'en-150');
    script.setAttribute('data-id', WEBSITE_KEY);
    script.defer = true;

    cookieDeclaration.value?.parentElement.appendChild(script);
  }

  onMounted(() => {
    loadCookieDeclaration(lang.value);
    stopWatch = watch(lang, (value) => loadCookieDeclaration(value));
  });

  onBeforeUnmount(() => {
    stopWatch?.();
    document.getElementById(SCRIPT_ID)?.remove();
  });
</script>
